import { ReactComponent as Bin } from 'assets/icons/bin.svg';
import { formatFileSize } from './AIDrivenSearchUploadFile.helper';
import styles from './AIDrivenSearchUploadFile.module.scss';

/**
 * @summary AIDrivenSearchUploadFile - Displays uploaded file or error state
 *
 * @param {boolean} [error] - Whether to show error state
 * @param {Object} file - File object or error object
 * @param {string} file.name - File name
 * @param {number} [file.size] - File size in bytes
 * @param {string} [file.description] - Error description
 * @param {number} [file.fileLimit] - Max file size for error display
 * @param {Function} handleDeleteDocument - Delete callback: (event, file) => void
 * @param {number} [disabled = false] - Disabled file upload.
 */
export const AIDrivenSearchUploadFile = ({
  error,
  file,
  disabled = false,
  handleDeleteDocument,
}) => {
  const handleDelete = event => {
    if (disabled === true) return;
    handleDeleteDocument(event, file);
  };

  return (
    <div
      className={`custom-drag-upload-static__uploading-progress ${
        error ? 'custom-drag-upload-static__uploading-error' : ''
      } ${styles.container}`}
    >
      <span id={styles.title} title={file.name || 'Δαπάνες Επένδυσης'}>
        {file.name || 'Δαπάνες Επένδυσης'}
      </span>
      <Bin
        id={styles.bin}
        aria-disabled={disabled}
        disabled={disabled}
        onClick={handleDelete}
        color={error ? '#B42318' : '#667085'}
      />
      <span id={styles.size}>{formatFileSize(file.size)}</span>
      <progress id={styles.progress} max={100} value={file ? 100 : 0} />
      <span id={styles.percent}>{`${file ? 100 : 0}%`}</span>
    </div>
  );
};
